import React from "react";
import { ICooperativeDetails } from "../../exports/interfaces";
import { formatDate } from "../../exports/functions";
import { Link, useNavigate } from "react-router-dom";
import useMobile from "../../hooks/useMobile";
import { Eye, Pencil } from "lucide-react";
import { usePermission } from "../../hooks/usePermission";

const getStatusClass = (status: string) => {
  switch (status) {
    case "Complete":
      return "pill-success";
    case "Inactive":
      return "pill-danger";
    case "Deactivated":
      return "bg-secondary";
    default:
      return "bg-secondary";
  }
};

const MemberInfo = ({
  cooperative,
}: {
  cooperative: ICooperativeDetails | null;
}) => {
  const isMobile = useMobile();
  const { canEdit } = usePermission();
  const navigate = useNavigate();
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h6 className="primary-color">Member list</h6>
        {canEdit("cooperatives") && (
          <button
            className="btn px-3 btn-badge fs-small"
            onClick={() =>
              navigate(`/register/edit/${cooperative?.id}`, {
                state: {
                  step: 4,
                },
              })
            }
          >
            <i className={`${!isMobile ? "me-2" : ""}`}>
              <Pencil size={15} />
            </i>
            {!isMobile && "Edit"}
          </button>
        )}
      </div>
      <div className="dashboard-card mt-3">
        <h6 className="text-uppercase mb-3">Upload History</h6>
        <div className="table-responsive admin-table table-checkbox">
          <table className="table align-middle">
            <thead>
              <tr>
                <th>Data Type</th>
                <th>Total Records</th>
                <th>Created Date</th>
                <th>Status</th>
                <th className="sticky-action">Action</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Share Members Data</td>
                <td>100</td>
                <td>
                  {formatDate(
                    new Date(cooperative?.shareMember?.createdAt || ""),
                  )}
                </td>
                <td>
                  <span
                    className={`badge rounded-pill px-3 py-2 ${getStatusClass("Complete")}`}
                  >
                    Complete
                  </span>
                </td>

                <td className="sticky-action">
                  <div className="d-flex gap-3 align-items-center">
                    <Link
                      to={`${process.env.REACT_APP_Url}${cooperative?.shareMember?.shareMemberUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View"
                      >
                        <Eye />
                      </i>
                    </Link>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Saving Members Data</td>
                <td>100</td>
                <td>
                  {formatDate(
                    new Date(cooperative?.shareMember?.createdAt || ""),
                  )}
                </td>
                <td>
                  <span
                    className={`badge rounded-pill px-3 py-2 ${getStatusClass("Complete")}`}
                  >
                    Complete
                  </span>
                </td>

                <td className="sticky-action">
                  <div className="d-flex gap-3 align-items-center">
                    <Link
                      to={`${process.env.REACT_APP_Url}${cooperative?.shareMember?.savingMemberUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View"
                      >
                        <Eye />
                      </i>
                    </Link>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Loan Members Data</td>
                <td>100</td>
                <td>
                  {formatDate(
                    new Date(cooperative?.shareMember?.createdAt || ""),
                  )}
                </td>
                <td>
                  <span
                    className={`badge rounded-pill px-3 py-2 ${getStatusClass("Complete")}`}
                  >
                    Complete
                  </span>
                </td>

                <td className="sticky-action">
                  <div className="d-flex gap-3 align-items-center">
                    <Link
                      to={`${process.env.REACT_APP_Url}${cooperative?.shareMember?.loanMemberUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View"
                      >
                        <Eye />
                      </i>
                    </Link>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr />
    </>
  );
};

export default MemberInfo;
